import { httpError } from 'actions/http'
import billing from 'admin/services/billing'
import { replace } from 'react-router-redux'
import { SINGLE_HIRE_PLAN } from 'app-constants'
import * as analytics from 'analytics/performance'

export const PLANS_REQUEST = 'PLANS_REQUEST'
export const PLANS_RECEIVE = 'PLANS_RECEIVE'
export const MERCHANTID_REQUEST = 'MERCHANTID_REQUEST'
export const MERCHANTID_RECEIVE = 'MERCHANTID_RECEIVE'
export const SUBSCRIPTION_NEEDED = 'SUBSCRIPTION_NEEDED'
export const SINGLE_HIRE_PURCHASED = 'SINGLE_HIRE_PURCHASED'
export const SINGLE_HIRES_UPDATE = 'SINGLE_HIRES_UPDATE'
export const ACTIVE_SUBSCRIPTION = 'ACTIVE_SUBSCRIPTION'

export const subscriptionNeeded = (payload = true) => (dispatch, getState) => {
  const whitelist = [
    '/admin/',
    '/admin/account',
    '/admin/account/billing',
    '/admin/account/subscribe',
  ]
  dispatch({ type: SUBSCRIPTION_NEEDED, payload })

  if (payload && whitelist.indexOf(getState().routing.locationBeforeTransitions.pathname) < 0) {
    dispatch(replace('/admin/'))
  }
}

export const activeSubscription = () => ({ type: ACTIVE_SUBSCRIPTION })

export const requestPlans = () => ({ type: PLANS_REQUEST })

export const receivePlans = payload => ({ type: PLANS_RECEIVE, payload })

export const requestMerchantId = () => ({ type: MERCHANTID_REQUEST })

export const receiveMerchantId = payload => ({ type: MERCHANTID_RECEIVE, payload })

export const singleHirePurchased = payload => ({ type: SINGLE_HIRE_PURCHASED, payload })

export const singleHiresUpdate = payload => ({ type: SINGLE_HIRES_UPDATE, payload })

function errorHandler(err, dispatch) {
  if ('response' in err) {
    const { response: { status = null } } = err
    if (status === 404) {
      dispatch(httpError(status))
    } else {
      throw err
    }
  } else {
    throw err
  }
}

function shouldFetch(state, key) {
  if (typeof state.admin.billing[key] !== 'undefined' && state.admin.billing[key].data.length > 0) {
    return false
  }
  if (state.admin.billing[key].isFetching) {
    return false
  }
  return true
}

export const fetchPlans = () => (dispatch) => {
  dispatch(requestPlans())
  return billing.getPlans()
    .then(result => dispatch(receivePlans(result)))
    .catch((err) => {
      errorHandler(err, dispatch)
    })
}

export const fetchPlansIfNeeded = params => (dispatch, getState) => {
  const { plans } = getState().admin.billing
  if (shouldFetch(getState(), 'plans')) {
    return dispatch(fetchPlans(params))
  }
  if (plans.isFetching) {
    dispatch(receivePlans(plans))
  }
  return Promise.resolve()
}

export const fetchMerchantId = () => (dispatch) => {
  dispatch(requestMerchantId())
  return billing.getMerchantId()
    .then(result => dispatch(receiveMerchantId(result)))
    .catch((err) => {
      errorHandler(err, dispatch)
    })
}

export const fetchMerchantIdIfNeeded = () => (dispatch, getState) => {
  if (shouldFetch(getState(), 'merchantId')) {
    return dispatch(fetchMerchantId())
  }
  return Promise.resolve()
}

export const requestQuote = payload => () => {
  analytics.onClickEvent({
    locationId: 'billingPage',
    id: 'requestQuoteButton',
    properties: {
      route: window.location.pathname,
    },
  })
  return billing.requestQuote(payload)
}

export const purchaseSingleHire = () => dispatch => billing.reCreateSubscription(SINGLE_HIRE_PLAN)
  .then(payload => dispatch(singleHirePurchased(payload)))
